import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import GuideIndexPage from './pages/guide/index.jsx';
import GuideLayout from './components/layout/GuideLayout.jsx';
import QueryIndexPage from './pages/query/index.jsx';
import QueryResultPage from './pages/query/result.jsx';
import QueryLayout from './components/layout/QueryLayout.jsx';
import ResultLayout from './components/layout/ResultLayout.jsx';
import AuthLayout from './components/layout/AuthLayout.jsx';
import PrintLayout from './components/layout/PrintLayout.jsx';
import AuthIndexPage from './pages/auth/index.jsx';
import AuthEmailPage from './pages/auth/email.jsx';
import AuthForgotPasswordPage from './pages/auth/forgotPassword.jsx';
import AuthChangePasswordPage from './pages/auth/changePassword.jsx';
import ProtectedRoute from './components/routing/ProtectedRoute';
import PublicRoute from './components/routing/PublicRoute';
import TokenHandler from './components/auth/TokenHandler';
import { ToastContainer, Bounce } from 'react-toastify';

const App = () => {
	const { isAuthenticated } = useAuth();

	return (
		<BrowserRouter>
			<TokenHandler />
			<ToastContainer
				className='mt-16'
				position='top-center'
				autoClose={5000}
				hideProgressBar={false}
				closeOnClick={false}
				pauseOnHover={true}
				draggable={false}
				progress={undefined}
				theme='colored'
				transition={Bounce}
			/>
			<Routes>
				<Route
					element={
						<ProtectedRoute>
							<QueryLayout />
						</ProtectedRoute>
					}
				>
					<Route index element={<QueryIndexPage />} />
				</Route>
				<Route
					element={
						<ProtectedRoute>
							<ResultLayout />
						</ProtectedRoute>
					}
				>
					<Route path='/query/:id' element={<QueryResultPage print={false} />} />
				</Route>
				<Route
					path='/query/:id/print'
					element={
						<ProtectedRoute>
							<PrintLayout />
						</ProtectedRoute>
					}
				>
					<Route path='/query/:id/print' element={<QueryResultPage print={true} />} />
				</Route>
				<Route
					element={
						<ProtectedRoute>
							<GuideLayout />
						</ProtectedRoute>
					}
				>
					<Route path='/guide' element={<GuideIndexPage />} />
				</Route>
				<Route
					path='/auth'
					element={
						<ProtectedRoute>
							<AuthLayout />
						</ProtectedRoute>
					}
				>
					<Route path='change-password' element={<AuthChangePasswordPage />} />
				</Route>
				<Route
					path='/login'
					element={
						<PublicRoute>
							<AuthLayout />
						</PublicRoute>
					}
				>
					<Route index element={<AuthIndexPage />} />
					<Route path='email' element={<AuthEmailPage />} />
					<Route path='forgot-password' element={<AuthForgotPasswordPage />} />
				</Route>
				<Route
					path='*'
					element={isAuthenticated ? <Navigate to='/' replace /> : <Navigate to='/login' replace />}
				/>
			</Routes>
		</BrowserRouter>
	);
};

export default App;
